import { List } from 'immutable';
import Raven from 'raven-js';
import { CONTACT } from 'customer-data-objects/constants/ObjectTypes';
import { CONTACT_TYPE_ID, denormalizeTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
import { useAssociationsQuery } from '../query/useAssociationsQuery';
import { useContactsQuery } from 'crm-activity-creator-data/contacts/useContactsQuery';
export const useContactRecords = ({
  objectTypeId,
  objectId
}) => {
  const isContactObjectType = objectTypeId === CONTACT_TYPE_ID;
  const {
    error,
    data
  } = useAssociationsQuery({
    objectId,
    objectTypeId,
    toObjectTypeName: CONTACT,
    skip: isContactObjectType
  });
  if (error) {
    Raven.captureException(error, {
      fingerprint: ['ERROR_API_CONTACT_ASSOCIATIONS_FAILED'],
      extra: {
        objectType: denormalizeTypeId(objectTypeId),
        objectId
      }
    });
  }
  const contactIds = isContactObjectType ? List([objectId]) : data ? data.associatedContacts : List();
  return useContactsQuery({
    contactIds,
    skip: contactIds.size === 0
  });
};